import Splide from "@splidejs/splide";
import { Lightbox } from "./pswp";

window.addEventListener("load", () => {
    const gallerySlides = document.querySelectorAll<HTMLElement>(".gallery-splide");
    const blogSplides = document.querySelectorAll<HTMLElement>(".blog-splide");

    gallerySlides.forEach(gallery => {
        const splide = new Splide(gallery, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: false,
            padding: '7.5vw',
            breakpoints: {
                767: { perPage: 2 },
                575: { perPage: 1 },
            }
        });

        splide.on('mounted', () => {
            new Lightbox(gallery);
            const slides = Array.from(gallery.querySelectorAll<HTMLElement>(".splide__slide"));
            const maxScaleY = 0.85;
            let initialized = false;

            const updateStyles = () => {
                if (splide.state.is(6) || splide.state.is(4) || splide.state.is(5) || !initialized) {
                    const center = window.innerWidth / 2;
                    initialized = true;

                    slides.forEach(slide => {
                        const rect = slide.getBoundingClientRect();
                        const slideCenter = rect.left + (rect.width / 2);
                        const distanceFromCenter = Math.abs(center - slideCenter);

                        const scaleY = maxScaleY + (1 - Math.min(1, distanceFromCenter / center)) * (1 - maxScaleY);
                        slide.style.transform = `scaleY(${scaleY})`;
                    });
                }
                requestAnimationFrame(updateStyles);
            };

            requestAnimationFrame(updateStyles);
        });

        splide.mount();
    });

    blogSplides.forEach(blog => {
        new Splide(blog, {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            gap: '23px',
            arrows: false,
            pagination: true,
            breakpoints: {
                991: {
                    perPage: 1,
                    perMove: 1,
                }
            }
        }).mount();
    });
});